import { motion } from "framer-motion";
import { Palette, Check } from "lucide-react";
import { useApp } from "@/context/AppProviders";

const Whitelabel = () => {
  const { t } = useApp();
  const w = t.whitelabel;

  return (
    <section
      id="whitelabel"
      data-testid="whitelabel-section"
      className="py-24 sm:py-32 border-t border-border"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-2 lg:items-center">
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5 }}
          >
            <p className="font-mono text-sm uppercase tracking-widest text-blue-500">
              {w.label}
            </p>
            <h2 className="font-heading mt-3 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight">
              {w.title}
            </h2>
            <p className="mt-4 text-base leading-relaxed text-muted-foreground">
              {w.subtitle}
            </p>
            <ul className="mt-6 space-y-3">
              {w.points.map((point) => (
                <li key={point} className="flex items-start gap-3 text-sm">
                  <Check className="mt-0.5 h-4 w-4 flex-shrink-0 text-blue-500" />
                  <span className="text-muted-foreground">{point}</span>
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="relative flex aspect-[4/3] items-center justify-center overflow-hidden rounded-sm border border-border bg-card"
          >
            <div className="grid-texture absolute inset-0 opacity-40" />
            <div className="relative flex flex-col items-center text-center">
              <div className="flex h-20 w-20 items-center justify-center rounded-sm bg-blue-600 text-white">
                <Palette className="h-10 w-10" strokeWidth={1.75} />
              </div>
              <div className="mt-5 flex gap-2">
                <span className="h-6 w-6 rounded-sm bg-blue-600" />
                <span className="h-6 w-6 rounded-sm bg-emerald-500" />
                <span className="h-6 w-6 rounded-sm bg-amber-500" />
                <span className="h-6 w-6 rounded-sm bg-foreground/80" />
              </div>
              <p className="mt-4 font-mono text-xs uppercase tracking-widest text-muted-foreground">
                Your Brand · Your Color · Your Logo
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Whitelabel;
